<template>
<div class="chapter">
<div class="inner_page">
<div class="preface" id="preface">
<div class="chapterHead">
<h2 class="chapterTitle1">PREFACE</h2>
</div>
<p class="paraNoIndent">‘Yellow 1’ lurched violently as the flak shell burst close alongside. Pieces of shrapnel tore into the fuselage and engine cowling. I knew instinctively that this was it, and half expected to see my past life flash before my eyes. But training took over. Hauling the stick back into my stomach, I pointed the nose of the Focke-Wulf skywards. I desperately needed to gain altitude, not only to escape the tracer being hosed up at me from the armada of ships beneath my wings, but also to give myself sufficient height to bale out.</p>
<p class="para">As I climbed, still under fire, I unbuckled my seat harness and disconnected the radio leads. Judging the time to be right, and before the labouring engine gave up the ghost altogether, I jettisoned the canopy and kicked the stick forwards. The machine bucked and I was catapulted clean out of the cockpit. Buffeted by the slipstream, I was thrown against the tailplane, but scarcely noticed what I took to be a glancing blow on my left shoulder.</p>
<p class="para">We had flown a wide arc out to sea before mounting our attack and now, fortunately, a stiff offshore breeze was carrying me towards the coastline. But I still couldn’t be sure whether I was going to come down in the shallows or make it to dry land. As I drifted closer, and despite the light flak that continued to flick past dangerously close to my parachute, I found myself reflecting on the twenty-three-year journey–the last five of those years in Luftwaffe uniform–that had brought me to my present predicament descending helplessly towards the Normandy invasion beaches…</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// LuftwaffeFighterPilot_preface.vue?fb90cf6c